__turbopack_context__.v({
  "tabContent": "CampaignTabContent-module__vtVzJq__tabContent",
});
